import {MouseEvent} from 'react';

import {LiftType} from 'common/report/util/lift/types';
import {ChartTooltipProps} from 'common/components/chart-tooltip';
import {SegmentFilterController} from 'common/charts/contexts/segment-filter-controller';

export type MetricFormatter = (segment: MetricSegment, value: number) => string;

export type TooltipDataCallback = (segment: MetricSegment) => ChartTooltipProps;

export type MetricChartClick = (ev: MouseEvent, metricSegment: MetricSegment) => void;

export enum MetricChartSize {
  Small = `small`,
  Medium = `medium`,
  Large = `large`,
}

export interface MetricSegment {
  liftComparisonValue?: number;
  comparisonValue?: number;
  label?: string;
  value: number;
  secondaryValue?: number;
  subLabel?: string;
  color?: string;
  path?: string[];
  stepIndex?: number;
}

export type MultiMetricChartProps = {
  elref?: string;
  hideValue?: boolean;
  hideSubValue?: boolean;
  liftType?: LiftType;
  metricSize?: MetricChartSize;
  metricFormatter: MetricFormatter;
  metrics: MetricSegment[];
  onMetricChartClick?: MetricChartClick;
  segmentFilterController?: SegmentFilterController;
  selectedMetric?: MetricSegment;
  tooltipDataCallback?: TooltipDataCallback;
};

export interface GridDimensions {
  columns: number;
  rows: number;
}

export interface GridSetup {
  maxWidth: number;
  maxHeight: number;
  dimensionsForMetrics: GridDimensions[];
}
